
export const SUPER_ADMIN = "competition_super_admin";
export const ADMIN = "competition_admin";
export const TEACHER = "teacher";
